import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useCallback, useContext, useMemo } from "react";

import { observer } from "mobx-react-lite";
import { StoreContext } from "../../store";
import useTranslation from "next-translate/useTranslation";
import { Box, Typography } from "@material-ui/core";
import { Section, SubmitButton, TextField } from "@microrealestate/commonui/components";
import { CustomSwitchField } from "@microrealestate/commonui/components/FormFields/SwitchField";
import { toJS } from "mobx";

const RentSettings = observer(({ onSubmit }) => {
  const { t } = useTranslation("common");
  const store = useContext(StoreContext);

  const initialValues = useMemo(() => {
    const selectedOrg = toJS(store.organization.selected);
    const { tenantSettings } = selectedOrg;

    return {
      requireTenantId: tenantSettings.requireTenantId,
    };
  }, [store.organization.selected]);

  const _onSubmit = useCallback(
    async (settings) => {
      const payload = {
        // V2 Schema
        tenantSettings: {
          ...settings,
          requireTenantId: settings.requireTenantId,
        },
        isTenantSettingUpdated: settings.requireTenantId !== initialValues.requireTenantId ?? false,

        // V1 Schema - deprecated
        // rents: {
        //   isTenantIDRequired: settings.requireTenantId,
        // },
      };
      await onSubmit(payload);
    },
    [onSubmit, initialValues]
  );

  return (
    <Formik initialValues={initialValues} onSubmit={_onSubmit}>
      {({ values, isSubmitting }) => {
        return (
          <Form>
            <Section label={t("Rents Settings")}>
              <Box display="flex" alignItems="flex-start" mb={1.5}>
                <CustomSwitchField name={`requireTenantId`} color="primary" />
                <Box ml={1}>
                  <Typography variant="subtitle1">{t("Required Tenant Identification")}</Typography>
                  <Typography variant="caption" color="textSecondary">
                    {t(
                      "Determines whether tenant identification is required at the time of move-in"
                    )}
                  </Typography>
                </Box>
              </Box>
            </Section>
            <SubmitButton size="large" label={!isSubmitting ? t("Save") : t("Saving")} />
          </Form>
        );
      }}
    </Formik>
  );
});

export default RentSettings;
